import { render, staticRenderFns } from "./DataPihakLain.vue?vue&type=template&id=8bc44bf0&"
import script from "./DataPihakLain.vue?vue&type=script&lang=js&"
export * from "./DataPihakLain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports